export const PAGE_SIZE = 30;
import type { PlanRowStatus, ProductionPlanPreview, ProductStage } from "./plan-import-types";
export function formatDate(value: string) {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match)
        return value;
    return new Intl.DateTimeFormat("tr-TR", {
        day: "numeric",
        month: "short",
        year: "numeric",
    }).format(new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
}
export function formatQuantity(value: number, unit = "") {
    return `${value.toLocaleString("tr-TR", { maximumFractionDigits: 3 })}${unit ? ` ${unit}` : ""}`;
}
export function formatClock(value: string) {
    return new Intl.DateTimeFormat("tr-TR", {
        timeZone: "Europe/Istanbul",
        hour: "2-digit",
        minute: "2-digit",
    }).format(new Date(value));
}
export function statusLabel(status: PlanRowStatus) {
    if (status === "PLAN_ONLY")
        return "İş emri bekleniyor";
    if (status === "WORK_ORDER_MATCHED")
        return "İş emri doğrulandı";
    if (status === "PARTIAL")
        return "Kısmi üretildi";
    if (status === "COMPLETED")
        return "Tamamlandı";
    return "Kontrol gerekli";
}
export function planRowStatusLabel(row: ProductionPlanPreview["rows"][number]) {
    if (row.workOrderMatch === "AMBIGUOUS")
        return `${row.candidateWorkOrderNos?.length ?? 0} iş emri adayı`;
    if (row.workOrderMatch === "MISSING")
        return "Mikro iş emri eksik";
    if (row.workOrderMatch === "MIKRO_BULK_Q" && row.status === "WORK_ORDER_MATCHED")
        return "Toplu Q iş emri doğrulandı";
    return statusLabel(row.status);
}
export function productStage(row: ProductionPlanPreview["rows"][number]): ProductStage {
    if (row.productStage)
        return row.productStage;
    if (row.outputCode.startsWith("19"))
        return "FINAL_19";
    if (row.outputCode.startsWith("21") || row.outputCode.startsWith("22"))
        return "BULK_SEMI_21_22";
    if (row.outputCode.startsWith("23"))
        return "PACKAGED_INTERMEDIATE_23";
    if (row.outputCode.startsWith("24"))
        return "UNPACKAGED_INTERMEDIATE_24";
    return "INTERNAL_OTHER";
}
export function productStageLabel(row: ProductionPlanPreview["rows"][number]) {
    const labels: Record<ProductStage, string> = {
        FINAL_19: "Nihai mamul",
        BULK_SEMI_21_22: "21/22 toplu yarı mamul",
        PACKAGED_INTERMEDIATE_23: "23 ambalajlı ara ürün",
        UNPACKAGED_INTERMEDIATE_24: "24 paketsiz ara ürün",
        INTERNAL_OTHER: "Diğer iç üretim",
    };
    return labels[productStage(row)];
}
export function workOrderMatchLabel(row: ProductionPlanPreview["rows"][number]) {
    if (row.workOrderMatch === "EXCEL")
        return "Excel iş emri";
    if (row.workOrderMatch === "MIKRO_PRODUCT_UNIQUE")
        return "Mikro ürün ve miktar eşleşmesi";
    if (row.workOrderMatch === "MIKRO_BULK_Q")
        return "Mikro toplu Q";
    return null;
}
